import {Link, isRouteErrorResponse, useRouteError} from "react-router";

export function ErrorBoundary() {
    const error = useRouteError();

    const isResponse = isRouteErrorResponse(error);
    const statusCode = isResponse ? error.status : null;
    const message = isResponse
        ? statusCode === 404
            ? "Page not found"
            : statusCode === 401
              ? "Unauthenticated"
              : statusCode === 403
                ? "Forbidden"
                : error.statusText
        : "Something went wrong";

    if (!isResponse) {
        console.log(error);
    }

    return (
        <div className="min-h-screen grid place-items-center text-center p-8">
            <div>
                {statusCode !== null && <div className="text-4xl mb-2">{statusCode}</div>}
                <div className="mb-16">{message}</div>
                <Link
                    to="/"
                    className="underline"
                >
                    Back to Home
                </Link>
            </div>
        </div>
    );
}
